var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutils = function SvgOutils(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.342 13.222-2.828 2.829 3.535 3.535L19.484 6.151 15.95 2.615l-2.121 2.122 1.414 1.414-1.415 1.414-1.414-1.414-2.121 2.121 2.121 2.122L11 11.808 8.878 9.686l-2.122 2.122 1.415 1.414-1.415 1.414zM16.656.494l4.95 4.95a1 1 0 0 1 0 1.414l-14.85 14.85a1 1 0 0 1-1.414 0l-4.95-4.95a1 1 0 0 1 0-1.415L15.243.494a1 1 0 0 1 1.414 0"
  })));
};
export default SvgOutils;